<template>
  <div class="filemgr-content-body" style="top:0; bottom: 0; position: inherit;">
  <!-- {{ boxSetting }} -->
    <div v-if="!boxSetting.hideToolbar" class="detail-content-header">
      <nav class="navbar wd-100p pd-0">
        <!-- <nav class="nav">
          <div
            class="nav-link dropdown"
            v-if="prms.boxChooser != undefined && prms.boxChooser"
          >
            <span
              class="dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <feather class="wd-20 ht-20" type="menu"></feather> Бүрдэлүүд
            </span>

            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a
                :class="{ 'active text-white': b.id == box.id }"
                :key="i"
                v-for="(b, i) in parentTask.b"
                class="dropdown-item"
                role="button"
                @click="$emit('load-box', b)"
              >
                {{ b.nm }}
              </a>
            </div>
          </div>

          <div class="nav-link dropdown">
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuBox">
              <li
                class="dropdown-item"
                role="button"
                @click="$emit('on-box-edit', box)"
              >
                Засах
              </li>
              <li
                class="dropdown-item tx-danger"
                role="button"
                @click="$emit('on-box-delete', box)"
              >
                Устгах
              </li>
            </ul>
            <div id="dropdownMenuBox" data-toggle="dropdown" role="button">
              <a class="btn btn-xs btn-outline-primary btn-uppercase mg-r-10">
                <feather type="tool" class="ht-15-f wd-15-f mg-r-5"></feather
                >Тохиргоо
              </a>
            </div>
          </div>
        </nav> -->
        <div class="">{{ box.nm }}</div>
        <div class="mg-l-auto d-flex">
          <b-pagination
            v-if="attachmentsCount > 0"
            class="mg-r-20"
            size="sm"
            align="center"
            v-model="pager.current"
            :total-rows="attachmentsCount"
            :per-page="pager.perPage"
            @change="pageChanged"
            style="margin-bottom: 0"
          ></b-pagination>
          <div class="dropdown dropleft">
            <button
              class="btn btn-xs btn-success btn-uppercase dropdown-toggle"
              id="dropdownMenuAttach"
              data-toggle="dropdown"
            >
              <feather type="plus-square"></feather> Файл хуулах
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuAttach">
              <!-- <a class="dropdown-item" href="#">Компютероос хуулах</a> -->
              <simple-uploader
                :boxId="box.id"
                :propObjectId="6"
                :propObjectTypeId="6"
                @on-success="fileUploaded($event)"
                class="wd-100p"
              >
                <div slot="trigger" class="wd-100p">
                  <a class="dropdown-item" href="#">Компютероос хуулах</a>
                </div>
              </simple-uploader>
              <a @click="showFinder()" role="button" class="dropdown-item"
                >Динамик драйваас сонгох</a
              >
            </div>
          </div>
        </div>
      </nav>
    </div>

    <div
      v-if="attachmentsCount == 0"
      class="container d-flex justify-content-center ht-100p"
    >
      <div
        class="mx-wd-300 wd-sm-450 d-flex flex-column align-items-center justify-content-center pd-t-100"
        style="height: calc(100vh - 220px)"
      >
        <div class="wd-80p wd-sm-300 mg-b-15">
          <img src="assets/svg/folder.svg" class="img-fluid" alt="" />
        </div>
        <p class="tx-color-03 mg-b-30 tx-center">Файл хуулаагүй байна.</p>
      </div>
    </div>
    <div v-else class="pd-x-10" :style="`height: ${boxSetting.listSetting.height=='auto'?'auto':'calc(100vh - 180px)'}`">
      <div class="row row-xs">
        <file-item
          @on-dropdown="mediaDropdown"
          :boxId="box.id"
          @un-link="unLinkPrompt"
          @on-setting="onSetting"
          :activeId.sync="activeFileId"
          @on-attach="$emit('on-attach', $event)"
          role="button"
          :obj="f"
          v-for="(f, i) in attachments"
          :key="i"
        ></file-item>
      </div>

      <b-overlay :show="busy" no-wrap>
        <template #overlay>
          <div
            v-if="processing"
            class="text-center p-4 bg-secondary text-light rounded"
          >
            <b-icon icon="info" font-scale="4"></b-icon>
            <div class="mb-3">Түр хүлээнэ үү...</div>
            <b-progress
              min="1"
              max="20"
              :value="18"
              variant="warning"
              height="5px"
              class="mx-n4 rounded-0"
            ></b-progress>
          </div>
          <div
            v-else
            ref="dialog"
            tabindex="-1"
            role="dialog"
            aria-modal="false"
            aria-labelledby="form-confirm-label"
            class="text-center p-3"
          >
            <p><strong id="form-confirm-label">Итгэлтэй байна уу?</strong></p>
            <div class="d-flex">
              <b-button
                variant="outline-danger"
                class="mr-3"
                @click="busy = false"
              >
                Үгүй
              </b-button>
              <b-button variant="outline-success" @click="unLink()"
                >Тийм</b-button
              >
            </div>
          </div>
        </template>
      </b-overlay>
    </div>

    <media-finder
      v-if="mediaFinder.show > 0"
      @on-attach="fileAttached"
      @on-task-close="mediaFinder.show = 0"
    ></media-finder>

    <file-settings
      :id="fileSetting.id"
      :boxId="fileSetting.boxId"
      @on-close="
        activeFileId = 0;
        fileSetting.id = null;
      "
    />
  </div>
</template>
<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";

export default {
  components: {
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    fileItem: () => ({
      component: import("@/components/modules/media/item"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    fileSettings: () => ({
      component: import("@/components/modules/media/section/settings.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    mediaFinder: () => ({
      component: import("@/components/modules/media/finder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    parentTask: {
      type: Object,
      default: () => {}
    },
    box: {
      type: Object,
      default: () => {}
    },
    prms: {
      type: Object,
      default: () => {}
    },
    detailSettingProp: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      boxSetting: {
        hideToolbar: false,
        hideAddButton: false,
        hideEmptyTemplate: false,
        hideFooter: false,
        listSetting: {
          height: 300,
          disableDetail: false
        }
      },
      loading: false,
      attachmentsCount: 0,
      attachments: [],
      pager: {
        current: 1,
        perPage: 12
      },
      mediaFinder: {
        show: false,
        id: 0,
        key: 0
      },
      activeFileId: 0,

      processing: false,
      busy: false,
      processingId: 0,
      fileSetting: {
        id: null,
        boxId: null,
        obj: {}
      }
    };
  },
  mounted() {
    require("@/assets/scss/pages/filemgr.scss");
    if (this.detailSettingProp != undefined && this.detailSettingProp.boxSetting!=undefined) {
      //console.log('this.detailSettingProp.boxSetting', this.detailSettingProp.boxSetting);
      let _bxs= this.detailSettingProp.boxSetting;
      if(_bxs.hideToolbar != undefined){
        this.boxSetting.hideToolbar= _bxs.hideToolbar;
      }
      if(_bxs.listSetting != undefined && _bxs.listSetting.height!=undefined){
        this.boxSetting.listSetting.height=_bxs.listSetting.height;
      }
      // this.boxSetting = this.detailSettingProp.boxSetting;
    }

    this.init();
    //console.log(this.box.id);
  },
  methods: {
    pageChanged(e) {
      this.pager.current = e;
      this.init();
    },
    init() {
      this.processing = true;
      this.busy = true;
      this.attachments = [];
      request({
        params: {
          id: this.box.id,
          size: this.pager.perPage,
          page: this.pager.current - 1
        },
        api: { method: "get", url: "Media/boxInAttachmentList" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.$emit("update-box-count", {
            boxId: this.box.id,
            count: res.data.attachmentsCount
          });
          this.processing = false;
          this.busy = false;
          this.attachmentsCount = res.data.attachmentsCount;
          this.attachments = res.data.attachments.map(function(e) {
            let ext = e.e;
            switch (e.e) {
              case "jpg":
              case "jpeg":
              case "png":
                ext = "image";
                break;
              case "doc":
              case "docx":
                ext = "word";
                break;
              case "xls":
              case "xlsx":
                ext = "excel";
                break;
              case "ppt":
              case "pptx":
                ext = "powerpoint";
                break;
              case "txt":
                ext = "alt";
                break;
              case "html":
              case "css":
              case "js":
                ext = "code";
                break;
              case "mp4":
                ext = "video";
                break;
              case "mp3":
                ext = "audio";
                break;
              default:
                break;
            }
            e.ext = ext;
            return e;
          });
        }
      });
      this.$emit("box-loaded");
    },
    fileUploaded() {
      //this.$emit('load-box', this.box);
      this.init();
    },
    fileAttached(e) {
      request({
        data: { boxId: this.box.id, attachmentId: e },
        api: { method: "post", url: "Box/AttachAttachment" },
        store: this.$store
      }).then(res => {
        this.mediaFinder.show = false;
        if (res != false) {
          this.init();
        }
      });

      //console.log(e);
    },
    unLinkPrompt(e) {
      this.mediaDropdown(e);
      this.processingId = e.id;
      //console.log(this.processingId);
      this.busy = true;
    },
    unLink() {
      this.processing = true;
      request({
        data: {
          boxId: this.box.id,
          attachmentId: this.processingId.toString()
        },
        api: { method: "post", url: "Box/DetachAttachment" },
        store: this.$store
      }).then(res => {
        this.mediaFinder.show = false;
        if (res != false) {
          this.processing = false;
          this.busy = false;
          this.init();
        }
      });
    },
    showFinder() {
      this.mediaFinder.show = true;
    },
    addItem(){
      this.showFinder();
    },
    mediaDropdown(e) {
      if (this.activeFileId != e.id) this.activeFileId = e.id;
      else this.activeFileId = 0;
    },
    onSetting(e) {
      this.fileSetting.boxId = this.box.id;
      this.fileSetting.id = e.id;
      this.fileSetting.obj = e;
    }
  }
};
</script>

<style></style>
